import './blocks/cta.js';
import './blocks/card-service.js';
import './blocks/card-destination.js';
import './blocks/hero-slider.js';
import './blocks/hero-slide.js';